import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import './testView.scss'
import TestForm from '../../../components/TestForm'
import html2pdf from 'html2pdf.js'
import Promise from 'bluebird'
import domtoimage from 'dom-to-image'
import html2canvas from 'html2canvas'

const DEFAULT_IMAGE_URL = 'https://static01.nyt.com/images/2017/11/04/autossell/04CLI-REPORT/merlin_129492995_7c3400d9-611c-43bb-b8bd-89c88eb9dfa9-superJumbo.jpg'

class TestView extends React.Component {
  static defaultProps = {
    device: {
      data: {
        unit_test_results: {
          communications: {},
          stage_move: {},
          autofocus: {
            autofocus_image_url: DEFAULT_IMAGE_URL
          },
          focus_mechanical: {},
          focus_image: {},
          linac_movements: {}
        }
      }
    },
    params: {},
    router: {},
    runCommunicationsTest: _.noop,
    runLinacMoveTest: _.noop,
    refreshDeviceData: _.noop,
    pushTestData: _.noop,
    version: null
  }

  static propTypes = {
    device: PropTypes.shape({
      data: {
        unit_test_results: {
          communications: {
            test_bluetooth_signalling: PropTypes.bool,
            test_camera_connected: PropTypes.bool,
            test_watchdog_running: PropTypes.bool
          },
          stage_move: {
            test_microsteps_working: PropTypes.bool
          }
        }
      }
    }),
    params: PropTypes.shape({}),
    router: PropTypes.shape({}),
    runCommunicationsTest: PropTypes.func,
    runStageTest: PropTypes.func,
    runLinacMoveTest: PropTypes.func,
    refreshDeviceData: PropTypes.func,
    pushTestData: PropTypes.func,
    version: PropTypes.string
  }

  constructor (props) {
    super(props)
    const { device_string } = props.params

    let unitTestResults = props.device.data.unit_test_results
    if (_.isEmpty(unitTestResults) || _.isEmpty(unitTestResults.communications)) {
      unitTestResults = {
        communications: {},
        autofocus: {
          autofocus_image_url: 'https://static01.nyt.com/images/2017/11/04/autossell/04CLI-REPORT/merlin_129492995_7c3400d9-611c-43bb-b8bd-89c88eb9dfa9-superJumbo.jpg',
          z_planes: []
        },
        stage_move: {
          test_microsteps_working: null
        },
        focus_image: {},
        linac_movements: {}
      }
    }

    unitTestResults.stage_move = unitTestResults.stage_move || {}
    unitTestResults.focus_mechanical = unitTestResults.focus_mechanical || {}
    unitTestResults.focus_image = unitTestResults.focus_image || {}
    unitTestResults.linac_movements = unitTestResults.linac_movements || {}
    unitTestResults.autofocus = unitTestResults.linac_movements || {}

    this.state = {
      loading: true,
      testGroups: [
        {
          key: 'communications',
          title: 'Automated Coms & Connectivity Test',
          tests: [
            {
              step: 'Bluetooth Signalling',
              manualStart: false,
              inputs: [
                {
                  key: 'test_bluetooth_signalling',
                  type: 'checkbox',
                  prompt: 'bluetooth process running?',
                  readOnly: true,
                  value: unitTestResults.communications.test_bluetooth_signalling
                }
              ]
            },
            {
              step: 'Camera Connected',
              manualStart: false,
              inputs: [
                {
                  key: 'test_camera_connected',
                  type: 'checkbox',
                  prompt: 'camera connection detected?',
                  readOnly: true,
                  value: unitTestResults.communications.test_camera_connected
                }
              ]
            },
            {
              step: 'Watchdog Running',
              manualStart: false,
              inputs: [
                {
                  key: 'test_watchdog_running',
                  type: 'checkbox',
                  prompt: 'watchdog process running',
                  readOnly: true,
                  value: unitTestResults.communications.test_watchdog_running
                }
              ]
            }
          ]
        },
        {
          key: 'stage_move',
          title: 'Stage Tests',
          tests: [
            {
              step: 'Microstep Stage Movements',
              manualStart: false,
              inputs: [
                {
                  key: 'test_microsteps_working',
                  type: 'checkbox',
                  prompt: 'stage drivenut working with microsteps?',
                  readOnly: true,
                  value: unitTestResults.stage_move.test_microsteps_working
                }
              ]
            }
          ]
        },
        {
          key: 'grid_image',
          title: 'Grid Image',
          z_planes: unitTestResults.autofocus.z_planes
        },
        {
          key: 'linac_movements',
          title: 'Linac Movements',
          tests: [
            {
              step: 'Move Linear Actuator to limits',
              manualStart: true,
              startTest: (e) => props.runLinacMoveTest(device_string) && e.preventDefault(),
              inputs: [
                {
                  type: 'checkbox',
                  key: 'test_strip_prox_sensor_active',
                  prompt: 'Does the stage turn blue when the fixture is inserted?',
                  value: unitTestResults.linac_movements.test_strip_prox_sensor_active
                },
                {
                  type: 'checkbox',
                  key: 'test_strip_start_position',
                  prompt: 'Front edge of test fixture strip moves to line on left side of stage?',
                  value: unitTestResults.linac_movements.test_strip_start_position
                },
                {
                  type: 'checkbox',
                  key: 'test_strip_home_position',
                  prompt: 'Graticule test fixture strip ejects such that it is removable by hand?',
                  value: unitTestResults.linac_movements.test_strip_home_position
                },
                {
                  type: 'checkbox',
                  key: 'test_strip_prox_sensor_inactive',
                  prompt: 'Does the light turn off when the fixture is removed from the stage?',
                  value: unitTestResults.linac_movements.test_strip_prox_sensor_inactive
                },
              ]
            }
          ]
        },
        {
          key: 'confirmation',
          title: 'Confirmation',
          tests: [
            {
              step: 'Operator Initials',
              manualStart: false,
              inputs: [
                {
                  key: 'confirm_operator_initials',
                  type: 'text',
                  prompt: 'Operator Initials',
                  placeholder: 'Operator Initials',
                  value: null
                }
              ]
            }
          ]
        }
      ]
    }
  }

  componentDidMount () {
    const { runCommunicationsTest, runStageTest, refreshDeviceData, params } = this.props
    const { device_string } = params
    refreshDeviceData(device_string)
    runCommunicationsTest(device_string)
    Promise.delay(20000)
    .then(() => runStageTest(device_string))
    this.pollId = setInterval(() => {
      refreshDeviceData(device_string)
      if (this.state.loading) {
        this.setState({
          loading: false
        })
      }
    }, 12000)
  }

  componentWillUnmount () {
    clearInterval(this.pollId)
  }

  componentWillReceiveProps (nextProps) {
    const { device } = nextProps
    const { testGroups } = this.state
    _.forEach(testGroups, (group) => {
      if (group.key === 'grid_image') {
        group.z_planes = _.get(device, ['data', 'unit_test_results', 'autofocus', 'z_planes']) || []
      }
      _.forEach(group.tests, (test) => {
        _.forEach(test.inputs, (check) => {
          if (_.isNull(check.value) || _.isUndefined(check.value)) {
            check.value = _.get(device, ['data', 'unit_test_results', group.key, check.key], false)
          } else if (_.get(device, ['data', 'unit_test_results', group.key, check.key]) && !check.value) {
            check.value = _.get(device, ['data', 'unit_test_results', group.key, check.key])
          }
        })
      })
    })
    this.setState({
      testGroups
    })
  }

  setValue = (key, value) => {
    const { testGroups } = this.state
    _.forEach(testGroups, (group) => {
      _.forEach(group.tests, (test) => {
        _.forEach(test.inputs, (input) => {
          if (input.key === key) {
            input.value = value
          }
        })
      })
    })
    this.setState({ testGroups })
  }

  goHome = () => {
    const { router } = this.props
    router.push('/')
  }

  submitTestData = (event) => {
    event.preventDefault()
    const { testGroups } = this.state
    const { params, pushTestData, device, router } = this.props
    const testResults = {}
    _.forEach(testGroups, (group) => {
      testResults[group.key] = {}
      _.forEach(group.tests, (test) => {
        _.forEach(test.inputs, (input) => {
          testResults[group.key][input.key] = input.value
        })
      })
    })
    testResults.autofocus = {
      'autofocus_image_url': _.get(device, 'data.unit_test_results.autofocus.autofocus_image_url')
    }
    var date = new Date()
    var utcDate = new Date(date.toUTCString())
    utcDate.setHours(utcDate.getHours() - 8)
    var usDate = new Date(utcDate).toJSON().slice(0, 10).replace(/-/g, '-')
    var filename = `FCT-${usDate}-${params.device_string}.jpg`
    //var filename = `FCT-${usDate}-${params.device_string}.jpg`
    pushTestData(params.device_string, testResults)


    html2canvas(document.body).then( (canvas) => {
      document.body.appendChild(canvas)
      const link = document.getElementById('downloadLink')
      var data = document.getElementsByTagName('canvas')[0].toDataURL('image/jpeg')
      link.setAttribute('href', data)
      link.click()  
      })
      .then(() => {
      router.push('/')
      })
    }

  clearTestData = (event) => {
    event.preventDefault()
    const { testGroups } = this.state
    _.forEach(testGroups, (group) => {
      if (group.key !== 'communications') {
        _.forEach(group.tests, (test) => {
          _.forEach(test.inputs, (input) => {
            if (input.type === 'checkbox') {
              input.value = false
            } else {
              input.value = ''
            }
          })
        })
      }
    })
    this.setState({
      testGroups
    })
  }

  render () {
    const { loading, testGroups } = this.state
    const { device, version } = this.props

    return (
      <div id='test'>
        <div className='version'>
          Software Version: {version}
        </div>
        <TestForm
          setValue={this.setValue}
          clearTestData={this.clearTestData}
          submitTestData={this.submitTestData}
          loading={loading}
          testGroups={testGroups}
          gridImageUrl={_.get(device, 'data.unit_test_results.autofocus.autofocus_image_url')}
          serialIdPlaceholder='Enter last 4 digits of device id'
          barcodeValue={device.device_string}
        />
      </div>
    )
  }
}

export default TestView



// WEBPACK FOOTER //
// ./src/routes/Test/components/TestView.js